import { render, staticRenderFns } from "./billInfo.vue?vue&type=template&id=d970553e&scoped=true"
import script from "./billInfo.vue?vue&type=script&lang=js"
export * from "./billInfo.vue?vue&type=script&lang=js"
import style0 from "./billInfo.vue?vue&type=style&index=0&id=d970553e&lang=css"
import style1 from "./billInfo.vue?vue&type=style&index=1&id=d970553e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d970553e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d970553e')) {
      api.createRecord('d970553e', component.options)
    } else {
      api.reload('d970553e', component.options)
    }
    module.hot.accept("./billInfo.vue?vue&type=template&id=d970553e&scoped=true", function () {
      api.rerender('d970553e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/billInfo.vue"
export default component.exports